export const AppLanguages = [
  {
    value: 'en',
    label: 'English',
  },
  {
    value: 'fr',
    label: 'Français',
  },
  {
    value: 'es',
    label: 'Español',
  },
  {
    value: 'ar',
    label: 'العربية',
  },
  {
    value: 'pa',
    label: 'ਪੰਜਾਬੀ',
  },
  {
    value: 'zh',
    label: '中文',
  },
] as const;

export function getLanguageLabel(language: string | undefined): string {
  const languageOption = AppLanguages.find((option) => option.value === language);
  return languageOption?.label ?? language ?? '-';
}
